import React, { StrictMode } from "react";
import reportWebVitals from "./reportWebVitals";
import { createRoot } from "react-dom/client";

import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/main.css";

import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import App from "./App";

import PostList from "./Routes/PostList";
import PostDetails from "./Routes/PostDetails";
import LandingPageTemplate from "./Routes/Landing";
import AboutPageTemplate from "./Routes/About";
import GetInvolvedTemplate from "./Routes/GetInvolved";
import ContactForm from "./Routes/ContactUs";
import MagazinePageTemplate from "./Routes/Magazine";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement:  <div><h1>error</h1></div>,
    children:[
      {
        path: "/",
        element: <LandingPageTemplate/>,
      },
      {
        path:"/about",
        element: <AboutPageTemplate/>
      },
      {
        path: "/news",
        element: <PostList/>,
      },
      {
        path: "/news/:slug",
        element: <PostDetails/>,
      },
      {
        path:"/get-involved",
        element: <GetInvolvedTemplate/>
      },
      {
        path:"/magazine",
        element: <MagazinePageTemplate/>
      },
      {
        path:"/contact",
        element: <ContactForm />
      },
      {
        path:"/terms",
        element: <div><h1>Terms of Use and Privacy Policy: comming soon</h1></div>
      },
    ]
  }
])
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);

reportWebVitals();
